<template>
  <div class="right_nav_meun">
    <div
    v-for="(item, index) in munList"
    :key="item.id"
    class="right_nav_meun_item"
    :class="item.onOff ? 'active' : ''"
    @mousemove="navMousemove(index)"
    @mouseleave="navMouseleave(index)"
    @click="itemClick(item.name)">
      <i :class=" 'iconfont '+ item.icon"></i>
      <span>{{item.name}}</span>
    </div>
    <div v-show="applyOnOff" class="right_nav_meun_apply_box" @mousemove="applyOnOff = true;munList[0].onOff = true" @mouseleave="applyOnOff = false;munList[0].onOff = false">
      <div class="right_nav_meun_apply_content">
        <div class="right_nav_meun_apply_live lf" @click.stop = "applyLive">
          <i class="suspension_live_icon"></i>
          <span>开始直播</span>
        </div>
        <div class="right_nav_meun_apply_text lf" @click.stop = "applyArticle">
          <i class="suspension_article_icon"></i>
          <span>发布文章</span>
        </div>
        <div class="right_nav_meun_apply_video lf" @click.stop = "applyVideo">
          <i class="suspension_video_icon"></i>
          <span>发布视频</span>
        </div>
        <!-- <div class="right_nav_meun_apply_train lf" @click.stop = "applyTrain">
          <i class="suspension_train_icon"></i>
          <span>发布培训</span>
        </div> -->
      </div>
      <div class="right_nav_meun_apply_right">
        <i class="suspensiong_icon_triangle"></i>
      </div>
    </div>
    <div v-show="erweimaOnOff" class="right_nav_meun_code_box">
      <img src="../../assets/img/telephoneDown/erweima.png" alt="安卓下载">
      <p>安卓手机浏览器扫描下载！</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Suspension',
  data () {
    return {
      munList: [
        { icon: 'suspensiong_faqi', name: '发起', onOff: false },
        // { icon: 'suspensiong_quanzi', name: '圈子', onOff: false },
        // { icon: 'iconfont icon-gouwuche', name: '购物车', onOff: false },
        { icon: 'suspensiong_erweima', name: 'APP下载', onOff: false },
        { icon: 'suspensiong_bangzhu', name: '帮助', onOff: false },
        { icon: 'suspensiong_fankui', name: '问题反馈', onOff: false },
        { icon: 'suspensiong_dingbu', name: '顶部', onOff: false }
      ],
      applyOnOff: false,
      erweimaOnOff: false
    }
  },
  methods: {
    // 鼠标移入
    navMousemove: function (i) {
      this.munList[i].onOff = true
      switch (this.munList[i].name) {
        case '发起':
          this.applyOnOff = true
          break
        case 'APP下载':
          this.erweimaOnOff = true
          break
      }
    },
    // 鼠标移出
    navMouseleave: function (i) {
      switch (this.munList[i].name) {
        case '发起':
          this.applyOnOff = false
          break
        case 'APP下载':
          this.erweimaOnOff = false
          break
      }
      this.munList[i].onOff = false
    },
    // 鼠标点击
    itemClick: function (name) {
      switch (name) {
        case '顶部':
          var scrollToptimer = setInterval(function () {
            const top = document.body.scrollTop || document.documentElement.scrollTop
            const speed = top / 4
            if (document.body.scrollTop !== 0) {
              document.body.scrollTop -= speed
            } else {
              document.documentElement.scrollTop -= speed
            }
            if (top === 0) {
              clearInterval(scrollToptimer)
            }
          }, 30)
          break
        case '圈子':
          this.$router.push({ name: 'CircleList' })
          break
        case 'APP下载':
          this.$router.push({ name: 'Down' })
          break
        case '问题反馈':
          window.open(this.$router.resolve({ path: '/feedback' }).href, '_blank')
          break
        case '帮助':
          this.$router.push({ name: 'UserGuide' })
          break
      }
    },
    // 鼠标点击发布直播
    applyLive: function () {
      const vueThat = this
      if (vueThat.loginVerification()) { // 验证是否登录
        const info = vueThat.$store.state.user.info
        // 验证是否通过播主认证
        if (info.is_authentication === 0) { // 未通过
          vueThat.myApi.isAnchor().then(res => { // 调用接口后台查询播主认证状态
            if (res.data.code === 200) {
              if (res.data.data.is_authentication === 0) { // 未认证，跳转认证页面
                vueThat.$alert('您还未进行播主认证！', '温馨提示', {
                  showConfirmButton: true,
                  iconClass: 'iconfont icon-jinggao',
                  confirmButtonText: '去认证',
                  callback: action => {
                    vueThat.$store.commit('editPersonalMeunAct', 'anchorCertification')
                    vueThat.$router.push({ path: '/anchorCertification' })
                  }
                }).catch(function (erro) {
                  console.log(erro)
                })
              } else { // 已验证修改localstore存储项，跳转发布页面
                info.is_authentication = res.data.data.is_authentication
                vueThat.$store.commit('user/updateUserInfo', info)
                vueThat.applyOnOff = false
                const routeData = vueThat.$router.resolve({
                  path: '/liveApply'
                })
                window.open(routeData.href, '_blank')
              }
            }
          })
        } else {
          vueThat.applyOnOff = false
          const routeData = vueThat.$router.resolve({
            path: '/liveApply'
          })
          window.open(routeData.href, '_blank')
        }
      }
    },
    // 鼠标点击发布文章
    applyArticle: function () {
      this.applyOnOff = false
      if (this.loginVerification()) {
        const routeData = this.$router.resolve({
          path: '/articleApply'
        })
        window.open(routeData.href, '_blank')
      }
    },
    // 鼠标点击发布视频
    applyVideo: function () {
      this.applyOnOff = false
      if (this.loginVerification()) {
        const routeData = this.$router.resolve({
          path: '/videoApply'
        })
        window.open(routeData.href, '_blank')
      }
    },
    // 鼠标点击发布培训
    applyTrain: function () {
      this.applyOnOff = false
      if (this.loginVerification()) {
        const routeData = this.$router.resolve({
          path: '/trainApply'
        })
        window.open(routeData.href, '_blank')
      }
    },
    // 登录验证
    loginVerification: function () {
      const vueThat = this
      const info = vueThat.$store.state.user.info
      if (info === null) {
        vueThat.$alert('您未登录账号，请登录后操作！', '温馨提示', {
          type: 'erro',
          iconClass: 'iconfont icon-icon_richeng_btn_cancel',
          confirmButtonText: '去登录',
          showClose: false,
          callback: () => {
            vueThat.$router.push({ name: 'Login' })
          }
        })
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped="scoped">
  .suspension_live_icon{
    background: url(../../assets/img/suspension/suspensionLive.png) no-repeat;
  }
  .right_nav_meun_apply_content div:hover i.suspension_live_icon{
    background-image: url(../../assets/img/suspension/suspensionLiveHover.png);
  }
  .suspension_video_icon{
    background: url(../../assets/img/suspension/suspensionVideo.png) no-repeat;
  }
  .right_nav_meun_apply_content div:hover i.suspension_video_icon{
    background-image: url(../../assets/img/suspension/suspensionVideoHover.png);
  }
  .suspension_article_icon{
    background: url(../../assets/img/suspension/suspensionArticle.png) no-repeat;
  }
  .right_nav_meun_apply_content div:hover i.suspension_article_icon{
    background-image: url(../../assets/img/suspension/suspensionArticleHover.png);
  }
  .suspension_train_icon{
    background: url(../../assets/img/suspension/suspensionTrain.png) no-repeat;
  }
  .right_nav_meun_apply_content div:hover i.suspension_train_icon{
    background-image: url(../../assets/img/suspension/suspensionTrainHover.png);
  }
  .right_nav_meun_item i.suspensiong_faqi{
    width: 27px;
    background: url(../../assets/img/iconList.png) no-repeat -32px -106px;
  }
  .right_nav_meun_item.active .suspensiong_faqi{
    background: url(../../assets/img/iconList.png) no-repeat -79px -106px;
  }
  .suspensiong_quanzi{
    background: url(../../assets/img/iconList.png) no-repeat -33px -151px;
  }
  .right_nav_meun_item.active .suspensiong_quanzi{
    background: url(../../assets/img/iconList.png) no-repeat -79px -151px;
  }
  .suspensiong_erweima{
    width: 18px;
    height: 28px;
    background: url(../../assets/img/iconList.png) no-repeat -31px -192px;
  }
  .right_nav_meun_item.active .suspensiong_erweima{
    background: url(../../assets/img/iconList.png) no-repeat -80px -192px;
  }
  .suspensiong_bangzhu{
    background: url(../../assets/img/iconList.png) no-repeat -32px -232px;
  }
  .right_nav_meun_item.active .suspensiong_bangzhu{
    background: url(../../assets/img/iconList.png) no-repeat -79px -232px;
  }
  .suspensiong_fankui{
    background: url(../../assets/img/iconList.png) no-repeat -318px -342px;
  }
  .right_nav_meun_item.active .suspensiong_fankui{
    background: url(../../assets/img/iconList.png) no-repeat -354px -342px;
  }
  .right_nav_meun_item .suspensiong_dingbu{
    background: url(../../assets/img/iconList.png) no-repeat -36px -275px;
    width: 18px;
    height: 18px;
  }
  .right_nav_meun_item.active .suspensiong_dingbu{
    background: url(../../assets/img/iconList.png) no-repeat -84px -275px;
  }
  .right_nav_meun{
    position:fixed;
    z-index: 10;
    width:67px;
    left: 50%;
    bottom: 10px;
    margin-left: 570px;
  }
  .right_nav_meun_item{
    width: 100%;
    height: 61px;
    padding: 8px 3px;
    margin-bottom: 4px;
    text-align: center;
    color: #767676;
    font-size: 14px;
    background-color: #f3f3f3;
    transition: all .8s;
  }
  .right_nav_meun_item i,.right_nav_meun_item span{
    display: block;
  }
  .right_nav_meun_item i{
    width: 25px;
    height: 28px;
    margin: 0 auto;
  }
  .right_nav_meun_item span{
    margin-top: 2px;
  }
  .right_nav_meun_item:hover{
    cursor: pointer;
  }
  .right_nav_meun_item.active{
    background-color: #d7b76d;
  }
  .right_nav_meun_item.active span{
    font-size: 14px;
    color: #fff;
  }
  .right_nav_meun_apply_box{
    position: absolute;
    overflow: hidden;
    width: 323px;
    right: 60px;
    top: -6px;
    z-index: 10;
  }
  .right_nav_meun_apply_content{
    z-index: 1;
  }
  .right_nav_meun_apply_content div{
    padding: 10px 20px;
    background-color: #d7b76d;
    border-right: 1px solid #fff;
  }
  .right_nav_meun_apply_content div:last-child{
    border-right: 1px solid #fff;
  }
  .right_nav_meun_apply_content div:hover{
    cursor: pointer;
    background-color: #f3d99e;
  }
  .right_nav_meun_apply_content div:hover span {
    color: #ab7d11;
  }
  .right_nav_meun_apply_content div i,.right_nav_meun_apply_content div span{
    display: block;
  }
  .right_nav_meun_apply_content div i{
    width: 35px;
    height: 33px;
    margin: 0 auto;
  }
  .right_nav_meun_apply_content div span{
    margin-top: 5px;
    text-align: center;
    color: #fff;
  }
  .right_nav_meun_apply_right {
    position: absolute;
    width: 10px;
    height: 16px;
    line-height: 10px;
    font-size: 12px;
    color: #ab7d11;
    top: 32px;
    right: 0;
    background: url(../../assets/img/suspension/triangle.png) no-repeat;
  }
  .right_nav_meun_code_box{
    position: absolute;
    width: 150px;
    height: auto;
    padding: 10px;
    background-color: #fff;
    right: 67px;
    top: 65px;
  }
  .right_nav_meun_code_box p{
    width: 150px;
    line-height: 25px;
    font-size: 12px;
    text-align: center;
    color: #888;
  }
</style>
